"use client";
import BackBtn from "./components/BackBtn";
import { PropertyUtilities2 } from "../../constants/utilitiesIcons";
import { AddressIcon } from "../design1/components/Listing";
import { Currency } from "src/types";
import { AddressLink } from "./ContactUs2";
import dayjs from "dayjs";
import { SideItem2 } from "./Sale2";
import { getCurrencySign } from "src/app/lib/getCurrencySign";
import { camelCaseToWords, ParentCard } from "../design1/PropertyPage1";
import ImageGrid from "./components/ImageGrid";
import { mockProperties } from "../../constants/mockProperties";
import React from "react";
import Example from "../design1/components/Map";
import utc from "dayjs/plugin/utc";
import { useParams } from "next/navigation";
import relativeTime from "dayjs/plugin/relativeTime";
import { PropertyType } from "src/types";
import { useState } from "react";
import { AnimatePresence, LazyMotion, m, domAnimation } from "framer-motion";
import useCompanyListingDetails from "src/app/lib/useFecthCompanyListing";
import PropertyCardSkeleton from "./components/Skeletons/PropertyCard";
import {
  generateSliderImages,
  SliderImagesProps,
} from "../design3/components/PropertyCarousel2";
import { ShowMoreText } from "../design1/About1";
import {
  formatPropertyInfo,
  formatTenantFields,
  newTenantsFields,
  PropertyFaq,
  renewalTenantsFields,
} from "src/app/serverUtils";
export interface PropertyCardProps {
  title: string;
  price: number;
  type?: string;
  category?: string;
  quote: string;
  propertyId?: string;
  address?: string;
  beforePrice?: number;
  discount?: string;
  quotePrice?: number | string;
  priceType?: string;
  className?: string;
}
export interface Advanced extends PropertyCardProps {
  variant?: boolean;
  loading?: boolean;
}
export const PropertyCard: React.FC<Advanced> = ({
  title,
  price,
  propertyId,
  type,
  quote,
  address,
  beforePrice,
  discount,
  category,
  quotePrice,
  loading,
  priceType,
  className,
  variant,
}) => {
  if (loading) {
    return <PropertyCardSkeleton loading={loading} />;
  }
  return (
    <div
      className={`items ${
        variant && "grid-container  !grid"
      } mt-6 mb-4 flex sm:flex-col xs:gap-3 xs:items-start items-center justify-between ${
        className || ""
      }`}
    >
      {/* Left Section */}
      <div className={`${variant && "flex justify-between"}`}>
        <div className={`first flex flex-col gap-3 ${variant && "!gap-2"}`}>
          {propertyId && (
            <div className={`if text-label-main ${variant && "text-xl"}`}>
              (Property ID: {propertyId})
            </div>
          )}
          <h1 className={`text-3xl ${variant && "font-semibold"}`}>{title}</h1>
          {address && (
            <div
              className={`addy ${
                variant && "text-[1.5rem]"
              } items-center sm:flex-col sm:items-start gap-3 flex`}
            >
              <div className="address flex items-center gap-3">
                <AddressIcon
                  color={variant ? "#606060" : ""}
                  className="!h-[25px] !w-[25px]"
                />
                <AddressLink
                  className="text-label-main capitalize"
                  address={address}
                />
              </div>
              <h6
                className={`text-themeColor capitalize ${variant && "!hidden"}`}
              >
                {category}
              </h6>
            </div>
          )}
        </div>

        {variant && (
          <h6 className="p-2 h-max px-3 capitalize text-xl bg-themeColor text-white rounded-xl">
            {category}
          </h6>
        )}
      </div>

      {/* Right Section - Pricing */}
      <div className="price flex flex-col sm:items-start  items-end">
        <div className="item  items-end  gap-1 flex">
          {discount && (
            <span
              className={`text-secondary-main hidden ${variant && "!block"}`}
            >
              Now
            </span>
          )}
          <h2
            className={`text-themeColor ${
              !variant && !discount && "5xl"
            }  leading-none w-max text-right`}
          >
            {beforePrice && (
              <span
                className={`text-secondary-main text-base block text-left line-through ${
                  variant && "text-right"
                }`}
              >
                Before: ₦{beforePrice.toLocaleString()}
              </span>
            )}
            ₦{price.toLocaleString()}
            {type && type === "rent" && (
              <div className=" text-xl text-secondary-main">
                {camelCaseToWords(priceType!)}
              </div>
            )}
          </h2>
          {discount && (
            <span
              className={`text-secondary-main hidden ${!variant && "block"}`}
            >
              Now
            </span>
          )}
        </div>

        {/* Other Pricing Info */}
        <div
          className={`other  flex gap-3 ${
            variant && discount && "text-[1.2rem]"
          }  ${variant && !discount && "text-[2rem]"}`}
        >
          {quotePrice && priceType && (
            <span className="text-secondary-main">
              <span className="text-themeColor">
                ₦{quotePrice.toLocaleString()}
              </span>{" "}
              / {camelCaseToWords(quote)}
            </span>
          )}
          {discount && (
            <span className="text-themeColor">
              {discount} Discount on Initial Price
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

dayjs.extend(relativeTime);
dayjs.extend(utc);
const Rent2 = () => {
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  // const property = findPropertyById(toNum)!;
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
  const {
    data: item,
    isError,
    isLoading,
  } = useCompanyListingDetails(toNum) as {
    data: PropertyType | undefined;
    isError: boolean;
    isLoading: boolean;
  };
  if (isLoading && !isDemo) {
    return <PropertyCardSkeleton variant loading={isLoading} />;
  }
  if (isError && !isDemo) {
    return <div>Error occurred</div>;
  }
  const property = isDemo ? mockProperties.forRent[0] : item;
  if (!property && !isDemo) {
    return <div>Not available</div>;
  }

  if (!property) {
    return <div>Data not available</div>;
  }
  const currency = getCurrencySign(property.currency) as Currency;
  // inside Rent2 component
  const newTenantsData = formatTenantFields(
    property,
    currency,
    newTenantsFields
  );
  const renewalTenantsData = formatTenantFields(
    property,
    currency,
    renewalTenantsFields
  );
  const info = formatPropertyInfo(property);
  const isOutRight = !property.beforePrice;
  const images = generateSliderImages(property.images);
  return (
    <section>
      <div className="wrapper pb-10 pt-5">
        <BackBtn dark />
        <PropertyCard
          loading={isLoading}
          type={property.type}
          quote={property.quote}
          title={property.title}
          category={property.category}
          price={property.price}
          propertyId={`${property.propertyId!}`}
          address={property.address}
          beforePrice={property?.beforePrice}
          discount={property.discount}
          quotePrice={property.quotePrice}
          priceType={property.priceType}
        />
        <div className="second">
          <ImageGrid
            images={
              [
                ...images,
                ...(property.videoLink
                  ? [{ url: property.videoLink, type: "video" }]
                  : []),
              ] as SliderImagesProps[]
            }
          />
        </div>

        <div className="grid-container relative mt-8">
          <div className="first flex flex-col gap-4">
            {" "}
            <ParentCard variant header="Property Brief">
              <ShowMoreText
                maxLength={300}
                text={property.propertyDesc || "No description available"}
              />
            </ParentCard>
            {property.facilities && property?.facilities?.length > 0 && (
              <ParentCard variant header="Facilities">
                <PropertyUtilities2 selectedItems={property?.facilities} />
              </ParentCard>
            )}
            <ParentCard variant header="Property Information">
              <KeyValueDisplay data={info} />
            </ParentCard>
            {!isOutRight && <Accordion data={PropertyFaq} />}
            <ParentCard variant header="New Tenants">
              <KeyValueDisplay money data={newTenantsData} />
            </ParentCard>
            <ParentCard variant header="Renewal Tenants">
              <KeyValueDisplay money data={renewalTenantsData} />
            </ParentCard>
            {property.coordinate && (
              <ParentCard variant header="Location">
                <Example coordinates={property.coordinate} />
              </ParentCard>
            )}
          </div>
          <SideItem2
            properties={property.staffListing}
            member={property.staff}
          />
        </div>
      </div>
    </section>
  );
};
export default Rent2;

interface KeyValueDisplayProps {
  data: Record<string, string | number>;
  money?: boolean;
}

export const KeyValueDisplay: React.FC<KeyValueDisplayProps> = ({ data }) => {
  return (
    <div className="flex flex-col max-w-[700px] gap-2">
      {Object.entries(data).map(([key, value]) => {
        if (
          value === "0" ||
          value === 0 ||
          value === "--" ||
          value === "none" ||
          value === "₦0" ||
          value === "0.00" ||
          value === null
        )
          return;
        return (
          <div key={key} className="flex justify-between gap-14 pb-2">
            <span className="font-medium whitespace-nowrap flex-1">{key}</span>
            <span className="font-semibold capitalize xs:text-right  text-left flex-1">
              {value}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export const CallIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5871 2.34385C16.5934 2.55525 18.4675 3.44512 19.8995 4.8663C21.3314 6.28747 22.2353 8.15481 22.4618 10.1595M14.5871 6.28121C15.5552 6.47211 16.4436 6.9496 17.1369 7.65171C17.8303 8.35382 18.2965 9.24813 18.4752 10.2186M22.4126 17.0302V19.9832C22.4137 20.2574 22.3576 20.5287 22.2477 20.7799C22.1379 21.0311 21.9768 21.2566 21.7748 21.4419C21.5728 21.6272 21.3343 21.7683 21.0746 21.8561C20.8149 21.944 20.5398 21.9766 20.2667 21.9519C17.2378 21.6224 14.3284 20.5874 11.7719 18.93C9.39356 17.4187 7.37714 15.4023 5.86585 13.0239C4.20263 10.4558 3.16739 7.53221 2.84393 4.48971C2.81933 4.2175 2.85168 3.94316 2.93892 3.68415C3.02615 3.42513 3.16637 3.18712 3.35063 2.98526C3.5349 2.78341 3.75917 2.62213 4.00918 2.5117C4.25919 2.40127 4.52945 2.3441 4.80276 2.34385H7.75578C8.23349 2.33914 8.69661 2.50831 9.05882 2.81981C9.42102 3.1313 9.6576 3.56388 9.72446 4.03691C9.84877 4.98201 10.0799 5.90994 10.4135 6.80291C10.5459 7.15522 10.5746 7.53812 10.4961 7.90623C10.4176 8.27434 10.2352 8.61223 9.97055 8.87986L8.72044 10.13C10.1217 12.5943 12.1621 14.6348 14.6265 16.036L15.8766 14.7859C16.1442 14.5213 16.4821 14.3389 16.8502 14.2604C17.2183 14.1819 17.6012 14.2105 17.9535 14.343C18.8465 14.6765 19.7744 14.9077 20.7195 15.032C21.1977 15.0994 21.6344 15.3403 21.9466 15.7087C22.2587 16.0771 22.4246 16.5475 22.4126 17.0302Z"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.94922 7.86028C2.94922 7.33816 3.15663 6.83741 3.52583 6.46821C3.89503 6.09902 4.39577 5.8916 4.9179 5.8916H18.6987C19.2208 5.8916 19.7215 6.09902 20.0907 6.46821C20.4599 6.83741 20.6673 7.33816 20.6673 7.86028V17.7037C20.6673 18.2258 20.4599 18.7265 20.0907 19.0957C19.7215 19.4649 19.2208 19.6724 18.6987 19.6724H4.9179C4.39577 19.6724 3.89503 19.4649 3.52583 19.0957C3.15663 18.7265 2.94922 18.2258 2.94922 17.7037V7.86028Z"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.94922 7.85645L11.8083 13.7625L20.6673 7.85645"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

interface AccordionProps {
  data: {
    questions: { question: string; answer: string }[];
  };
}
export const Accordion: React.FC<AccordionProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="w-full bg-white rounded-2xl">
      {data.questions.map((item, index) => (
        <div key={index} className=" py-2 last:border-none">
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full text-left transition-all text-secondary-main duration-500 flex justify-between items-center"
          >
            {item.question}
            <span
              className={`text-themeColor  transform transition-all duration-500 text-2xl ${
                index === openIndex ? "rotate-[180deg]" : "rotate-0"
              }`}
            >
              <Angle />
            </span>
          </button>
          <LazyMotion features={domAnimation}>
            <AnimatePresence>
              {openIndex === index && (
                <m.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{
                    duration: 0.3,
                    ease: "easeInOut",
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="pl-4 text-secondary-main"
                >
                  {item.answer}
                </m.div>
              )}
            </AnimatePresence>
          </LazyMotion>
        </div>
      ))}
    </div>
  );
};

export const Angle = () => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49983 0.166821H16.4998C16.6517 0.167298 16.8006 0.209184 16.9304 0.287971C17.0602 0.366756 17.1661 0.47946 17.2367 0.613949C17.3072 0.748439 17.3397 0.899622 17.3307 1.05122C17.3218 1.20283 17.2716 1.34911 17.1857 1.47432L9.68566 12.3077C9.37483 12.7568 8.6265 12.7568 8.31483 12.3077L0.814827 1.47432C0.728014 1.34937 0.677106 1.20301 0.667631 1.05116C0.658157 0.899304 0.69048 0.747757 0.761089 0.612983C0.831697 0.478209 0.93789 0.36536 1.06813 0.286702C1.19837 0.208043 1.34768 0.166582 1.49983 0.166821Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
